import { getters } from '/@/modules/core/app/helpers/store';
import { AuthUser } from '@/modules/auth/models/AuthUser';
import { ManageEstateRouteConfig } from '@/modules/estate/routes/ManageEstateRouteConfig';

export class FinancialAdvisorProRouteConfig extends ManageEstateRouteConfig {
  canAccessRoute(): boolean {
    const user: AuthUser | null = getters.auth.getUser();
    if (!user || !super.canAccessRoute()) {
      return false;
    }

    return user.isInFinancialAdvisorProfessionGroup && !!user.permission?.canViewAdvisorProUpsells;
  }
}
